export default "__VITE_ASSET__rwpxvlbY__"